<script lang="ts" setup>
  defineOptions({ name: 'RelatedWorkSelect' })

  import { ref, onMounted, onBeforeUnmount } from 'vue'
  import type { RelatedWorkItem } from '@/types/relatedWork'
  import { RELATED_WORK_ASSETS, STORAGE_KEYS, RELATED_WORK_GUIDE_DURATION } from './constants'

  defineProps<{
    selectedWork: RelatedWorkItem | null
  }>()

  const emit = defineEmits<{
    'update:selectedWork': [work: RelatedWorkItem | null]
    'openPicker': []
  }>()

  const isGuideVisible = ref(false)
  let guideTimer: ReturnType<typeof setTimeout> | null = null

  onMounted(() => {
    const shown = localStorage.getItem(STORAGE_KEYS.RELATED_WORK_GUIDE_SHOWN)
    if (!shown) {
      isGuideVisible.value = true
      localStorage.setItem(STORAGE_KEYS.RELATED_WORK_GUIDE_SHOWN, '1')
      guideTimer = setTimeout(() => {
        isGuideVisible.value = false
      }, RELATED_WORK_GUIDE_DURATION)
    }
  })

  onBeforeUnmount(() => {
    if (guideTimer) clearTimeout(guideTimer)
  })

  const dismissGuide = () => {
    isGuideVisible.value = false
  }

  const handleRowPress = () => {
    dismissGuide()
    emit('openPicker')
  }
</script>

<template>
  <div class="related-work-select-wrap">
    <div class="related-work-setting-row" @click="handleRowPress">
      <div class="related-work-setting-row-left">
        <!-- <img :src="RELATED_WORK_ASSETS.settingRowIcon" class="related-work-row-icon" alt="" /> -->
        <span class="related-work-row-label">关联作品</span>
      </div>
      <div class="related-work-setting-row-right">
        <span v-if="selectedWork" class="related-work-row-status">已关联作品</span>
        <span class="related-work-row-arrow hitems-arrow-right" />
      </div>
    </div>
    <div v-if="isGuideVisible" class="related-work-guide-bubble" @click="dismissGuide">
      <div class="related-work-guide-arrow" />
      <span>来试试关联作品，为作品增加热度～</span>
    </div>
  </div>
</template>

<style lang="stylus" scoped>
  @import './relatedWork.styl'
</style>
